import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import { GQLDeliveryUnitSaleCatalog, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { ErrorComponent, JwlField, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  sourceDeliveryUnitSaleCatalog: GQLDeliveryUnitSaleCatalog;
  party: GQLParty;
  onClose: (success: boolean, newDeliveryUnitSaleCatalogId: string) => void;
}

export const DeliveryUnitSaleCatalogDuplicateDialog: React.FC<IProps> = ({
  sourceDeliveryUnitSaleCatalog: sourceDetliveryUnitSaleCatalog,
  party,
  onClose
}: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [deliveryUnitSaleCatalogToPersist, setDeliveryUnitSaleCatalogToPersist] = useState(null as any);
  const initialValues = {
    name: sourceDetliveryUnitSaleCatalog.name.en,
    description: sourceDetliveryUnitSaleCatalog.description.en
  };

  const [
    duplicateDeliveryUnitSaleCatalog,
    { error: errorDuplicateDeliveryUnitSaleCatalog, loading: createDuplicateDeliveryUnitSaleCatalogLoader }
  ] = GQLOperationBuilder.deliveryUnitSaleCatalog.createFromDeliveryUnitSaleCatalog();

  const onSubmit = (props: any) => {
    const mutationVariables = {
      name: { en: props.name },
      description: { en: props.description },
      deliveryUnitSaleCatalogId: sourceDetliveryUnitSaleCatalog.id
    };

    setDeliveryUnitSaleCatalogToPersist(props);
    duplicateDeliveryUnitSaleCatalog({ variables: mutationVariables }).then(response => {
      onClose(
        true,
        GQLOperationBuilder.deliveryUnitSaleCatalog.deliveryUnitSaleCatalogIdFromResponse(response.data)
      );
    });
  };

  if (errorDuplicateDeliveryUnitSaleCatalog && !errorComponentState)
    return (
      <Dialog open={true} maxWidth="md" aria-labelledby="duplicate-delivery-unit-sale-catalog">
        <ErrorComponent
          margins="0"
          close={setErrorComponentState}
          callback={() => onSubmit(deliveryUnitSaleCatalogToPersist)}
          details={errorDuplicateDeliveryUnitSaleCatalog?.stack}
          message={errorDuplicateDeliveryUnitSaleCatalog?.message}
        />
      </Dialog>
    );

  if (createDuplicateDeliveryUnitSaleCatalogLoader) return <LoadingSpinner />;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required')
  });

  return (
    <Dialog open={true} aria-labelledby="duplicate-delivery-unit-sale-catalog">
      <Fragment>
        <DialogTitle>Duplicate delivery unit catalog</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ ...initialValues }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, touched, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name" component={JwlField} label="Name" />
                <Field name="description" component={JwlField} label="Description" />

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false, '')}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};

export default DeliveryUnitSaleCatalogDuplicateDialog;
